import * as React from "react";
import SelectedMessageEntitiesProvider from "views/components/contexts/SelectedMessageEntitiesProvider";
import useSelectableMessageTableMessages from "./useSelectableMessageTableMessages";
const MessageTableSelectedEntitiesProvider = ({ children = null, bulkSelection = void 0 }) => {
  const { selectableMessageTableMessages } = useSelectableMessageTableMessages();
  return /* @__PURE__ */ React.createElement(
    SelectedMessageEntitiesProvider,
    {
      initialSelection: bulkSelection == null ? void 0 : bulkSelection.initialSelection,
      onChangeSelection: bulkSelection == null ? void 0 : bulkSelection.onChangeSelection,
      entities: selectableMessageTableMessages
    },
    children
  );
};
export const toSelectableMessageTableEntry = (message) => {
  var _a;
  return {
    index: message.index,
    message: {
      ...message.fields,
      _id: message.id,
      timestamp: String((_a = message.fields.timestamp) != null ? _a : "")
    },
    highlight_ranges: message.highlight_ranges,
    decoration_stats: message.decoration_stats
  };
};
export default MessageTableSelectedEntitiesProvider;
